import { AbstractReportPmsApiService } from '../abstract-report.service';
import { TaxReportCollection } from '../../../models/reports/financial/tax-report-collection.model';

/**
 * @class TaxesReportPmsApiService
 * @extends {AbstractReportPmsApiService<TaxReportCollection>}
 */
export class TaxesReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/financial/taxes';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {TaxReportCollection}
     * @protected
     */
    newModel(attributes, ...params) {

        return new TaxReportCollection(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/financial/tax-report.service.js